// src/views/ErrorView.js
import React from 'react';

const ErrorView = () => {
  return (<div>Error: Page not found</div>);
};

export default ErrorView;